import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    drawerState: null,
    isAdminProfile: false,
    appSettingFormName: null,
    customerFormName: null,
    propertyFormName: null,
    show_drawer: false,
    deleteBtnLoading: false,
    editLandlordData: {},
    editAreaData: {},
    editCustomerData: {},
    editFacilityData: {},
    editBlockData: {},
    editUnitTypeData: {},
    isEditUnitType: false,
    isEditBlock: false,
    isEditLandlord: false,
    isEditArea: false,
    isEditCustomer: false,
    isEditFacility: false,
    editPropertyTypeData: {},
    isEditPropertyType: false,
    editLandlordPlanData: {},
    isEditLandlordPlan: false,
    editPropertyData: {},
    isEditProperty: false,
    isEditUnit: false,
    editUnitData: {},
    isEditContactUs: false,
    editContactUsData: {},
    isEditBooking: false,
    editBookingData: {},
    imageBaseUrl: "",
    editLandmarkData: {},
    isEditLandmark: false,
    isEditPromotion: false,
    editPromotionData: {},
    appSettings: {},
    isRequestLandlord: false,
    editRequestLandlord: {},
    isEditContract: false,
    isEditCurrency: false,
    editCurrencyData: {},
    isEditLandlordValidityPlan: false,
    editLandlordValidityPlan: {},
    toggleBtnLoading: false
  },
  mutations: {
    IS_EDIT_CONTRACT(state, payload) {
      state.isEditContract = payload;
    },
    toggleDrawerState(state) {
      state.drawerState = !state.drawerState;
    },
    APP_SETTINGS_FORMNAME(state, payload) {
      state.appSettingFormName = payload;
    },
    PROPERTY_FORMNAME(state, payload) {
      state.propertyFormName = payload;
    },
    CUSTOMER_FORMNAME(state, payload) {
      state.customerFormName = payload;
    },
    SHOW_RIGHTSIDE_DRAWER(state, payload) {
      state.show_drawer = payload;
    },
    EDIT_LANDLORD(state, payload) {
      state.editLandlordData = payload;
    },
    IS_EDIT_LANDLORD(state, payload) {
      state.isEditLandlord = payload;
    },
    DRAWER_STATE(state, payload) {
      state.drawerState = payload;
    },
    DELETE_BTN_LOADING(state, payload) {
      state.deleteBtnLoading = payload;
    },
    IS_EDIT_AREA(state, payload) {
      state.isEditArea = payload;
    },
    EDIT_AREA(state, payload) {
      state.editAreaData = payload;
    },
    IS_EDIT_CUSTOMER(state, payload) {
      state.isEditCustomer = payload;
    },
    EDIT_CUSTOMER(state, payload) {
      state.editCustomerData = payload;
    },
    IS_EDIT_FACILITY(state, payload) {
      state.isEditFacility = payload;
    },
    EDIT_FACILITY(state, payload) {
      state.editFacilityData = payload;
    },
    IS_EDIT_BLOCK(state, payload) {
      state.isEditBlock = payload;
    },
    EDIT_BLOCK(state, payload) {
      state.editBlockData = payload;
    },
    IS_EDIT_UNIT_TYPE(state, payload) {
      state.isEditUnitType = payload;
    },
    EDIT_UNIT_TYPE(state, payload) {
      state.editUnitTypeData = payload;
    },
    IS_EDIT_PROPERTY_TYPE(state, payload) {
      state.isEditPropertyType = payload;
    },
    EDIT_PROPERTY_TYPE(state, payload) {
      state.editPropertyTypeData = payload;
    },
    IS_EDIT_LANDLORD_PLAN(state, payload) {
      state.isEditLandlordPlan = payload;
    },
    EDIT_LANDLORD_PLAN(state, payload) {
      state.editLandlordPlanData = payload;
    },
    IS_EDIT_PROPERTY(state, payload) {
      state.isEditProperty = payload;
    },
    EDIT_PROPERTY(state, payload) {
      state.editPropertyData = payload;
    },
    IS_EDIT_UNIT(state, payload) {
      state.isEditUnit = payload;
    },
    EDIT_UNIT(state, payload) {
      state.editUnitData = payload;
    },
    IS_EDIT_CONTACT_US(state, payload) {
      state.isEditContactUs = payload;
    },
    EDIT_CONTACT_US(state, payload) {
      state.editContactUsData = payload;
    },
    IS_EDIT_BOOKING(state, payload) {
      state.isEditBooking = payload;
    },
    EDIT_BOOKING(state, payload) {
      state.editBookingData = payload;
    },
    IMAGE_BASE_URL: (state, payload) => (state.imageBaseUrl = payload),
    IS_EDIT_LANDMARK(state, payload) {
      state.isEditLandmark = payload;
    },
    EDIT_LANDMARK(state, payload) {
      state.editLandmarkData = payload;
    },
    IS_EDIT_PROMOTION(state, payload) {
      state.isEditPromotion = payload;
    },
    EDIT_PROMOTION(state, payload) {
      state.editPromotionData = payload;
    },
    APP_CONFIGURATION(state, payload) {
      state.appSettings = payload;
    },
    IS_REQUEST_LANDLORD(state, payload) {
      state.isRequestLandlord = payload;
    },
    IS_ADMIN_PROFILE(state, payload) {
      state.isAdminProfile = payload;
    },
    EDIT_REQUEST_LANDLORD(state, payload) {
      state.editRequestLandlord = payload;
    },
    IS_EDIT_CURRENCY(state, payload) {
      state.isEditCurrency = payload;
    },
    EDIT_CURRENCY(state, payload) {
      state.editCurrencyData = payload;
    },
    IS_EDIT_LANDLORD_VALIDITY_PLAN(state, payload) {
      state.isEditLandlordValidityPlan = payload;
    },
    EDIT_LANDLORD_VALIDITY_PLAN(state, payload) {
      state.editLandlordValidityPlan = payload;
    },
    TOGGLE_BTN_LOADING(state, payload) {
      state.toggleBtnLoading = payload;
    }
  },
  getters: {
    isEditContract: state => state.isEditContract,
    isRequestLandlord: state => state.isRequestLandlord,
    editRequestLandlord: state => state.editRequestLandlord,
    imageBaseUrl: state => state.imageBaseUrl,
    appSettings: state => state.appSettings,
    showDrawer: state => state.show_drawer,
    editLandloard: state => state.editLandlordData,
    isEditLandlord: state => state.isEditLandlord,
    editArea: state => state.editAreaData,
    editPromotion: state => state.editPromotionData,
    isEditPromotion: state => state.isEditPromotion,
    isEditArea: state => state.isEditArea,
    editCustomer: state => state.editCustomerData,
    isEditCustomer: state => state.isEditCustomer,
    editFacility: state => state.editFacilityData,
    isEditFacility: state => state.isEditFacility,
    editBlock: state => state.editBlockData,
    editLandmark: state => state.editLandmarkData,
    isEditBlock: state => state.isEditBlock,
    isEditLandmark: state => state.isEditLandmark,
    editUnitType: state => state.editUnitTypeData,
    isEditUnitType: state => state.isEditUnitType,
    editPropertyType: state => state.editPropertyTypeData,
    isEditPropertyType: state => state.isEditPropertyType,
    editLandlordPlan: state => state.editLandlordPlanData,
    isEditLandlordPlan: state => state.isEditLandlordPlan,
    editProperty: state => state.editPropertyData,
    isEditProperty: state => state.isEditProperty,
    editUnit: state => state.editUnitData,
    isEditUnit: state => state.isEditUnit,
    editContactUs: state => state.editContactUsData,
    isEditContactUs: state => state.isEditContactUs,
    editBooking: state => state.editBookingData,
    isEditBooking: state => state.isEditBooking,
    drawerState: state => state.drawerState,
    deleteBtnLoading: state => state.deleteBtnLoading,
    appSettingFormName: state => state.appSettingFormName,
    customerFormName: state => state.customerFormName,
    propertyFormName: state => state.propertyFormName,
    isEditCurrency: state => state.isEditCurrency,
    editCurrency: state => state.editCurrencyData,
    isEditLandlordValidityPlan: state => state.isEditLandlordValidityPlan,
    editLandlordValidityPlan: state => state.editLandlordValidityPlan,
    toggleBtnLoading: state => state.toggleBtnLoading
  },
  actions: {},
  modules: {}
});
